// extracted by mini-css-extract-plugin
export default {"stripe-button":"stripe_stripe-button__MBXkN"};